export const api_url = {
    base_url: "https://instadispatch.madibana.com/APIV2/",
}
